
import { Vue, Component, Prop } from 'vue-property-decorator'
// import Dialog from '../Dialog.vue';
import RankList from './RankList.vue'
import { action, store } from '@/common/store'
import { dayRankID, totalRankID } from '@/common/config'
import logger from '@plat-components/utils2/_esm5/logger'
import { isElementInViewport, throttle, getElementByAttr } from '@common/utils'
import biliActEvents from '@bilibili/bili-act-events'
@Component({
  name: 'Rank',
  components: { RankList },
})
export default class Rank extends Vue {
  select = 'day'
  show = false
  isLogger = false
  mounted() {
    action.getRankList(dayRankID)
    action.getRankList(totalRankID)
  }

  get rankList() {
    if (this.select === 'day') {
      return store.rankList
    } else {
      return store.totalRankList
    }
  }
  get leftRankList() {
    return this.rankList.filter((item: any) => {
      return item.id % 2 ===0
    })
  }
  get rightRankList() {
    return this.rankList.filter((item: any) => {
      return item.id % 2 !==0
    })
  }
  selectDay() {
    this.select = 'day'
  }
  selectTotal() {
    this.select = 'total'
  }
  clickRule() {
    this.show = true
    biliActEvents.emit('OPEN_DIALOG')
  }
}

